import type { PlanStatus } from '@vy/types';
import { PLAN_STATUSES } from '@vy/types';
import cn from 'classnames';
import type { HTMLAttributes } from 'react';
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

type PlanStatusProps = HTMLAttributes<HTMLSpanElement> & {
  status: PlanStatus;
};

export const PlanStatusChip = forwardRef<HTMLSpanElement, PlanStatusProps>(
  ({ status, className, ...props }, ref) => {
    return (
      <span
        className={twMerge(
          cn(
            'mt-2 font-medium uppercase px-2.25 py-1.25 rounded-2lg w-fit',
            { 'text-active bg-active': status === PLAN_STATUSES.Active },
            { 'text-error bg-error': status === PLAN_STATUSES.Error },
            { 'text-inactive bg-[#FFF7F7]': status === PLAN_STATUSES.Inactive },
          ),
          className,
        )}
        ref={ref}
        {...props}
      >
        {status}
      </span>
    );
  },
);
